import { useEffect, useState } from "react";
import { Hammer } from "lucide-react";

export const FloatingCTA = ({ t }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#quote"
      data-testid="floating-cta"
      className={`fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 bg-[#D4AF37] text-[#2D1810] px-6 py-4 text-sm font-semibold rounded-full shadow-[0_8px_32px_rgba(62,39,35,0.35)] hover:bg-[#c9a227] hover:-translate-y-1 transition-[opacity,transform,background-color] duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <Hammer size={16} />
      {t.floating}
    </a>
  );
};
